import hupassApi from 'app/hupassApi';
import { userInfoState } from 'app/recoil/userInfoState';
import { useCallback, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useRecoilState } from 'recoil';
import { getErrorToastOptions, toast } from '../toast/toast';
import { setSignedInProperty } from 'app/ga-auth';

export const useUserInfo = () => {
  const [cookies, , removeCookie] = useCookies(['user', 'token']);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);

  useEffect(() => {
    if (
      cookies.user &&
      typeof cookies.user === 'string' &&
      cookies.token &&
      typeof cookies.token === 'string'
    ) {
      hupassApi.GetUserInfo(cookies.user, cookies.token).then(
        (res) => {
          setUserInfo(res.data);
          setLoading(false);
        },
        (e) => toast(getErrorToastOptions(e as Error))
      );
    } else {
      setLoading(false);
    }
  }, [cookies, setUserInfo]);

  useEffect(() => {
    if (!loading) {
      setSignedInProperty(!!userInfo);
    }
  }, [loading, userInfo]);

  const onLogout = useCallback(() => {
    removeCookie('user');
    removeCookie('token');
    setUserInfo(undefined);
  }, [removeCookie, setUserInfo]);

  return { userInfo, onLogout };
};
